var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFundBuyerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3726",
    "data-name": "Rectangle 3726",
    width: 50,
    height: 60,
    transform: "translate(73 2059)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_582",
    "data-name": "Mask Group 582",
    transform: "translate(-73 -2059)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BPD-icon2-pro-07",
    transform: "translate(73 2067.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M20.9,42.429l3.808.982a1.1,1.1,0,0,0,.287.037,1.037,1.037,0,0,0,.239-.029V25.024Z",
    fill: "#3bc1d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M2.049,1.1A5.242,5.242,0,0,0,0,5.279v27.64a5.276,5.276,0,0,0,3.948,5.106L20.9,42.44l4.337-17.4V5.014L6.6.173A5.231,5.231,0,0,0,2.049,1.1",
    fill: "#359ebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M30.608,3.495,25.237,5.014V25.042Z",
    fill: "#b8aba1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M46.049,38.025A5.279,5.279,0,0,0,50,32.919V5.279A5.276,5.276,0,0,0,43.411.173l-12.8,3.322L25.237,25.042V43.437h.052Z",
    fill: "#e2ded6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M12.4,16.923a1.2,1.2,0,0,1-.261,0,1.159,1.159,0,0,1-.776-.614l-1-2.071a1.148,1.148,0,1,1,2.06-.993l.368.776,5.614-4.415a1.148,1.148,0,1,1,1.427,1.8l-6.729,5.283a1.151,1.151,0,0,1-.706.246",
    fill: "#d91a32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M12.251,34.059a5.54,5.54,0,1,1,5.537-5.518,5.54,5.54,0,0,1-5.537,5.518m0-8.782A3.245,3.245,0,1,0,15.5,28.523a3.245,3.245,0,0,0-3.245-3.245",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M12.251,20.079A5.537,5.537,0,1,1,14.738,9.595,1.148,1.148,0,1,1,13.7,11.644a3.2,3.2,0,0,0-1.471-.342,3.245,3.245,0,1,0,2.943,4.577,1.158,1.158,0,0,1,2.115.942,5.551,5.551,0,0,1-5.04,3.26",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M30.476,13.244a1.148,1.148,0,0,1-.287-2.255L43.084,7.637a1.148,1.148,0,0,1,.578,2.207L30.767,13.193a1.126,1.126,0,0,1-.291.037",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M30.476,18.586a1.148,1.148,0,0,1-.287-2.259l12.895-3.348a1.148,1.148,0,1,1,.578,2.207L30.767,18.549a1.126,1.126,0,0,1-.291.037",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M30.476,29.291a1.148,1.148,0,0,1-.287-2.255l12.895-3.351a1.148,1.148,0,0,1,.578,2.207L30.767,29.24a1.126,1.126,0,0,1-.291.037",
    fill: "#00c9db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M30.476,34.637a1.148,1.148,0,0,1-.287-2.263l12.895-3.351a1.148,1.148,0,0,1,.578,2.207L30.767,34.578a1.126,1.126,0,0,1-.291.037",
    fill: "#d91a32"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundBuyerIcon);
export default __webpack_public_path__ + "static/media/fund-buyer-icon.6e0c5827ba1df39c2330422370557d3f.svg";
export { ForwardRef as ReactComponent };